// src/store/store.js
import { configureStore } from '@reduxjs/toolkit'
import rootReducer from './rootReducer'

// Middleware personnalisé pour la messagerie flottante
const messagingMiddleware = (store) => (next) => (action) => {
  // Intercepter certaines actions pour synchroniser avec l'état local
  if (action.type?.startsWith('floatingMessaging/')) {
    const result = next(action)

    // Déclencher des événements personnalisés pour la synchronisation
    if (action.type === 'floatingMessaging/addMessageToConversation') {
      window.dispatchEvent(
        new CustomEvent('messagingStateChanged', {
          detail: { type: 'newMessage', payload: action.payload },
        }),
      )
    }

    return result
  }

  return next(action)
}

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignorer ces chemins pour les Maps et Sets
        ignoredPaths: [
          'floatingMessaging.openConversations',
          'floatingMessaging.typingUsers',
          'floatingMessaging.onlineUsers',
          'floatingMessaging.messagesCache',
          'floatingMessaging.usersCache',
        ],
        ignoredActions: [
          'floatingMessaging/setTypingUsers',
          'floatingMessaging/setOnlineUsers',
          'floatingMessaging/openConversation',
          'floatingMessaging/closeConversation',
        ],
      },
    }).concat(messagingMiddleware),
  devTools: process.env.NODE_ENV !== 'production',
})

window.store = store

export default store
